export const CASH = 'DIRECT'
export const CREDIT_CARD = 'CREDIT_CARD'
export const CASH_CHANGER = 'CASH_CHANGER'
export type PaymentMethod = typeof CASH | typeof CREDIT_CARD | typeof CASH_CHANGER

/** 領収書に出力する支払い方法の1件分（APIリクエスト用） */
export type PaymentMethodInput = {
  method: 'cash' | 'credit_card' | 'other'
  /** method === 'other' のときのみ使用 */
  otherName?: string
  /** 複数の支払い方法を選択した場合に設定 */
  amount?: number
}

export type SalesDetailPdfParams = {
  checkinId?: string
  reservationId?: string
  filterGuestRoomAssignId?: string[]
  guestName: string
  provision: string
  isEnOutput: number
  paymentMethods?: PaymentMethodInput[]
}

export type SalesSplitDetailPdfParams = {
  checkinId?: string
  reservationId?: string
  isEnOutput: number
  splitReceipt: Array<{
    provision: string
    guestName: string
    salesId: string[]
    paymentMethods?: PaymentMethodInput[]
    filterGuestRoomAssignId?: string[]
  }>
}
